import {
  TEDCustomDateTimeDisplayer,
  IInternalDateFormat,
} from './TEDCustomDateTimeDisplayer';
import { TEDParseDateTimeMode, ValueType } from '../FormatterTypes';

class TEDDisplayIntAsYear extends TEDCustomDateTimeDisplayer {
  public static getInstance(): TEDDisplayIntAsYear {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayIntAsYear;

  asDateTime(
    value: ValueType,
    params: string,
    defaultParams: string
  ): IInternalDateFormat {
    if (typeof value === 'string' && value.length === 8) {
      return super.asDateTime(value, params, defaultParams);
    } else {
      let year = valToInt(value, -1);

      if (year < 0) {
        year = -1;
      }

      return {
        ty: year,
        tm: -1,
        td: -1,
        th: -1,
        tn: -1,
        ts: -1,
        tms: -1,
      };
    }
  }

  mode() {
    return TEDParseDateTimeMode.pdmY;
  }
}

const valToInt = (value: ValueType, defaultValue: number = 0): number => {
  let result: number = defaultValue;
  if (typeof value === 'string') {
    result = parseInt(value, 10) || defaultValue;
  }
  if (typeof value === 'boolean') {
    result = defaultValue;
  }
  if (typeof value === 'number') {
    result = Number.isInteger(value) ? value : Math.ceil(value);
  }

  // To match delphi, take the last 4 digits

  const resAsStr = result.toString();

  return parseInt(resAsStr.substr(Math.max(0, resAsStr.length - 4)), 10);
};

export { TEDDisplayIntAsYear };
